/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Proxy_Progress_LabelInputs */

const en_iconik_proxy_progress_label = /** @type {(inputs: Iconik_Proxy_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proxy import progress`)
};

const fr_iconik_proxy_progress_label = /** @type {(inputs: Iconik_Proxy_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progression de l'import du proxy`)
};

const de_iconik_proxy_progress_label = /** @type {(inputs: Iconik_Proxy_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proxy-Importfortschritt`)
};

const it_iconik_proxy_progress_label = /** @type {(inputs: Iconik_Proxy_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avanzamento dell'importazione del proxy`)
};

const ru_iconik_proxy_progress_label = /** @type {(inputs: Iconik_Proxy_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ход импорта прокси`)
};

const es_iconik_proxy_progress_label = /** @type {(inputs: Iconik_Proxy_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progreso de la importación de proxy`)
};

const zh_cn2_iconik_proxy_progress_label = /** @type {(inputs: Iconik_Proxy_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代理导入进度`)
};

const ja_iconik_proxy_progress_label = /** @type {(inputs: Iconik_Proxy_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロキシインポートの進行状況`)
};

const hi_iconik_proxy_progress_label = /** @type {(inputs: Iconik_Proxy_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रॉक्सी आयात प्रगति`)
};

const pt_pt2_iconik_proxy_progress_label = /** @type {(inputs: Iconik_Proxy_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progresso da importação de proxy`)
};

/**
* | output |
* | --- |
* | "Proxy import progress" |
*
* @param {Iconik_Proxy_Progress_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_proxy_progress_label = /** @type {((inputs?: Iconik_Proxy_Progress_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Proxy_Progress_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_proxy_progress_label(inputs)
	if (locale === "de") return de_iconik_proxy_progress_label(inputs)
	if (locale === "it") return it_iconik_proxy_progress_label(inputs)
	if (locale === "ru") return ru_iconik_proxy_progress_label(inputs)
	if (locale === "es") return es_iconik_proxy_progress_label(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_proxy_progress_label(inputs)
	if (locale === "ja") return ja_iconik_proxy_progress_label(inputs)
	if (locale === "hi") return hi_iconik_proxy_progress_label(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_proxy_progress_label(inputs)
	return en_iconik_proxy_progress_label(inputs)
});